module.exports = __webpack_public_path__ + "img/blockchain.3e615b4a.png";